// The space between the top of the hero and the bottom of the screen, so the hero can end at the fold.
// Measured again only when the width changes or the hero moves (an announcement bar app arriving late),
// so a phone's toolbar hiding on scroll doesn't resize it.
(function () {
  const heroes = document.querySelectorAll('[data-jak-collab-fold]');
  if (!heroes.length) return;
  const measure = () => {
    const width = window.innerWidth;
    heroes.forEach((hero) => {
      const top = Math.round(hero.getBoundingClientRect().top + window.scrollY);
      if (hero.dataset.foldWidth == width && hero.dataset.foldTop == top) return;
      hero.dataset.foldWidth = width;
      hero.dataset.foldTop = top;
      hero.style.setProperty('--jak-collab-fold', `${Math.max(window.innerHeight - top, 320)}px`);
    });
  };
  measure();
  window.addEventListener('resize', measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(document.body);
})();

if (!customElements.get('jak-collab-video')) {
  customElements.define(
    'jak-collab-video',
    class JakCollabVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.pauseToggle = this.querySelector('[data-pause-toggle]');
        this.soundToggle = this.querySelector('[data-sound-toggle]');
        this.cover = this.querySelector('[data-play]');

        if (this.pauseToggle) this.pauseToggle.addEventListener('click', this.togglePause.bind(this));
        if (this.soundToggle) this.soundToggle.addEventListener('click', this.toggleSound.bind(this));
        if (this.cover) this.cover.addEventListener('click', this.playWithSound.bind(this));

        // Looping hero film: respect people who ask for less motion.
        if (this.hasAttribute('data-loop') && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        }
        this.video.addEventListener('play', this.update.bind(this));
        this.video.addEventListener('pause', this.update.bind(this));
        this.video.addEventListener('volumechange', this.update.bind(this));
        this.update();
      }

      togglePause() {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }

      toggleSound() {
        this.video.muted = !this.video.muted;
        if (!this.video.muted && this.video.paused) this.video.play();
      }

      playWithSound() {
        this.setAttribute('data-playing', '');
        this.video.muted = false;
        this.video.controls = true;
        this.video.play();
        this.video.focus();
      }

      update() {
        if (this.pauseToggle) {
          this.pauseToggle.textContent = this.video.paused ? this.pauseToggle.dataset.labelPlay : this.pauseToggle.dataset.labelPause;
        }
        if (this.soundToggle) {
          this.soundToggle.textContent = this.video.muted ? this.soundToggle.dataset.labelOn : this.soundToggle.dataset.labelOff;
        }
      }
    }
  );
}
